import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({}))

export const Title = styled('div', ({ $theme }) => ({
    ...$theme.typography.LabelLarge,
    fontWeight: 700,
    marginBottom: '1.6rem'
}))

export const TermsContainer = styled('label', () => ({
    display: 'flex',
    marginBottom: '1rem'
}))

export const TermsTextContainer = styled('label', () => ({
    fontSize: '12px',
    padding: '15px'
}))

export const TermsCheckBox = styled('input', () => ({
    marginRight: '8px'
}))

export const SectionTitle = styled('span', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    fontWeight: 400,
    width: '12.5rem'
}))
